import { NotFound } from "../../component";

const PageNotFound = () => {
  return <NotFound />;
};

export default PageNotFound;